exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k8s-zero-data-max-width {\n  width: 100%; }\n\n.k8s-zero-data {\n  margin-bottom: 100px; }\n\n.k8s-zero-workloads-data {\n  margin-bottom: 80px;\n  margin-top: 80px; }\n\n.k8s-zero-services-data,\n.k8s-zero-service-pods-data {\n  margin-bottom: 80px; }\n\n.k8s-zero-filter-data {\n  margin: 106px 0px; }\n", ""]);

// exports
